// Port of api/fuel/app/classes/insights/hindex/types.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'types',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: ['type'],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_collection || !owner.get_count_collection()) return {}

        var baseIndex = this._data.current.get_index_level()

        var types = []

        var typeFilter = (filter && filter.type) ? filter.type : 'category'
        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        var exclude = (typeFilter === 'category') ? [1042, 1044] : []
        var limit = detail ? 100 : 5

        var excludeClause = exclude.length ? ' AND l.' + table + '_id NOT IN (' + Util.in(exclude) + ')' : ''

        var rankedTypes = Util.query(
            'SELECT l.' + table + '_id AS t,' +
            ' group_concat(DISTINCT l.game_id) as g,' +
            ' COUNT(DISTINCT l.game_id) as c,' +
            ' t.' + table + '_name AS n' +
            ' FROM game_' + table + ' l, ' + table + ' t' +
            ' WHERE l.game_id IN (' + Util.in(baseIndex) + ')' +
            ' AND t.' + table + '_id = l.' + table + '_id' +
            excludeClause +
            ' GROUP BY l.' + table + '_id' +
            ' ORDER BY COUNT(DISTINCT l.game_id) DESC, t.' + table + '_name ASC' +
            ' LIMIT 0, ' + limit
        )

        var typeIndex = []
        var gameIndex = []

        for (var i = 0; i < rankedTypes.length; i++) {
            typeIndex.push(parseInt(rankedTypes[i].t, 10))
            var gids = rankedTypes[i].g ? rankedTypes[i].g.split(',') : []
            for (var gi = 0; gi < gids.length; gi++) {
                if (gids[gi]) gameIndex.push(gids[gi])
            }
        }

        if (!gameIndex.length) gameIndex = [0]
        if (!typeIndex.length) typeIndex = [0]

        var typeGames = Util.query(
            'SELECT l.' + table + '_id AS t, l.game_id as g, AVG(r.rating_value) AS r' +
            ' FROM game_' + table + ' l' +
            ' LEFT JOIN rating r ON r.game_id = l.game_id' +
            ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
            ' WHERE l.game_id IN (' + Util.in(gameIndex) + ')' +
            ' AND l.' + table + '_id IN (' + Util.in(typeIndex) + ')' +
            ' GROUP BY l.' + table + '_id, l.game_id' +
            ' ORDER BY AVG(r.rating_value) DESC, l.game_id ASC',
            null, 't', true
        )

        for (var ri = 0; ri < rankedTypes.length; ri++) {
            var rankedType = rankedTypes[ri]
            var ratings = []

            var tGames = typeGames[rankedType.t] ? typeGames[rankedType.t].slice(0, 3) : []

            for (var rj = 0; rj < tGames.length; rj++) {
                var game = tGames[rj]
                ratings.push({
                    id: parseInt(game.g, 10),
                    rating: game.r ? parseFloat(game.r) : '-'
                })
                this._references.games.push(parseInt(game.g, 10))
            }

            types.push({
                id: parseInt(rankedType.t, 10),
                name: rankedType.n,
                count: parseInt(rankedType.c, 10),
                games: ratings
            })
        }

        return {
            types: types
        }

    }
})
